// orderNavigationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const orderNavigationSlice = createSlice({
  name: "orderNavigation",
  initialState: { targetEventId: null },
  reducers: {
    setTargetEventId: (state, action) => {
      state.targetEventId = action.payload;
    },
    clearTargetEventId: (state) => {
      state.targetEventId = null;
    },
  },
});

export const { setTargetEventId, clearTargetEventId } = orderNavigationSlice.actions;
export default orderNavigationSlice.reducer;
